import { Link } from "react-router-dom";

import withLayoutOptions from "../../components/withLayoutOptions/withLayoutOptions";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageMotherB.module.scss";

function PageMotherB() {
  const getImgSet = useImgSet();

  const content = getImgSet("content__p14", "png", s.content);
  const pointer = getImgSet("pointer__mother", "png", s.pointer);

  const back = getImgSet("back__p22", "png");
  const imgA = getImgSet("bear__02", "png", s.img__a);

  return (
    <div className={s.root}>
      {pointer}
      <div className={s.aside_left}>
        <Link to="/mother/" className={s.back}>
          {back}
        </Link>
        {imgA}
      </div>
      <div className={s.inner}>{content}</div>
    </div>
  );
}

export default withLayoutOptions(PageMotherB);
